export const billingBranches = [
  {
    address: {
      street_address1: "Office No. 1, Ground Floor, 16/6, Pinnac Appartment",
      street_address2:
        "Erandwane Co Op Society, Hotel Ashwamedha Residency, Erandwane",
      city: "Pune",
      postal_code: "411004",
      country: "India",
      state: "Maharashtra",
      state_code: "MH",
    },
    _id: "66168d0bbee689ae950805b2",
    zb_branch_id: "912468000012111015",
    autonumbergenerationgroup_id: "912468000012092962",
    autonumbergenerationgroup_name: "Sales Maharashtra",
    branch_name: "Maharashtra",
    createdAt: "2024-04-10T12:58:51.459Z",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "27ABDCS8429E1Z6",
    tax_settings_id: "912468000012111010",
    updatedAt: "2024-04-10T12:58:51.459Z",
    website: "",
  },
  {
    address: {
      street_address1: "7HF-8/2, B. H. Colony, Bahadurpur",
      street_address2: "",
      city: "Patna",
      postal_code: "800026",
      country: "India",
      state: "Bihar",
      state_code: "BR",
    },
    _id: "69aae94d76f33d48b27d7e2d",
    zb_branch_id: "912468000061033056",
    autonumbergenerationgroup_id: "912468000060901414",
    autonumbergenerationgroup_name: "Sales Bihar 25",
    branch_name: "Bihar",
    createdAt: "2026-03-06T14:48:45.786Z",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "10ABDCS8429E1ZL",
    tax_settings_id: "912468000060901409",
    updatedAt: "2026-03-06T14:48:45.786Z",
    website: "",
  },
  {
    address: {
      street_address1: "868, 8th Floor, Vegas Mall",
      street_address2: "Dwarka Sec 14",
      city: "Delhi",
      postal_code: "110075",
      country: "India",
      state: "Delhi",
      state_code: "DL",
    },
    _id: "648af94a25fe698084a2f413",
    zb_branch_id: "912468000000114901",
    autonumbergenerationgroup_id: "912468000002878391",
    autonumbergenerationgroup_name: "Sales Delhi",
    branch_name: "Delhi",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: true,
    phone: "7838116500",
    tax_reg_no: "07ABDCS8429E1Z8",
    tax_settings_id: "912468000000000271",
    website: "",
  },
  {
    address: {
      street_address1:
        "Kalpana Market, 1st Floor, GNB Road, Kamrup Metropolitan",
      street_address2: "",
      city: "Guwahati",
      postal_code: "781003",
      country: "India",
      state: "Assam",
      state_code: "AS",
    },
    _id: "648af94a25fe698084a2f41e",
    zb_branch_id: "912468000003099293",
    autonumbergenerationgroup_id: "912468000003099263",
    autonumbergenerationgroup_name: "Sales Assam",
    branch_name: "Assam",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "18ABDCS8429E1Z5",
    tax_settings_id: "912468000003099185",
    website: "",
  },
  {
    address: {
      street_address1: "2nd Floor, Plot No. 4, Minarch Tower,",
      street_address2: "Sector-44",
      city: "Gurugram",
      postal_code: "122003",
      country: "India",
      state: "Haryana",
      state_code: "HR",
    },
    _id: "648af94b25fe698084a2f429",
    zb_branch_id: "912468000000124010",
    autonumbergenerationgroup_id: "912468000002878481",
    autonumbergenerationgroup_name: "Sales Haryana",
    branch_name: "Haryana",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "06ABDCS8429E1ZA",
    tax_settings_id: "912468000000124005",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1:
        "#1207/343 & 1207/1/343/1, 9th Main, 7th Sector, HSR Layout",
      street_address2: "",
      city: "Bengaluru",
      postal_code: "560102",
      country: "India",
      state: "Karnataka",
      state_code: "KA",
    },
    _id: "648af94b25fe698084a2f435",
    zb_branch_id: "912468000001732038",
    autonumbergenerationgroup_id: "912468000002878661",
    autonumbergenerationgroup_name: "Sales Karnataka",
    branch_name: "Karnataka",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "29ABDCS8429E1Z2",
    tax_settings_id: "912468000001732003",
    website: "",
  },
  {
    address: {
      street_address1:
        "3rd Floor, Suite No. 37, B-8, Sector-2, Noida, Gautam Buddha Nagar",
      street_address2:
        "3RD FLOOR, 305, PU3, SATGURU PARINAY, SCHEME NO. 54, A.B ROAD",
      city: "Indore",
      postal_code: "452010",
      country: "India",
      state: "Madhya Pradesh",
      state_code: "MP",
    },
    _id: "648af94b25fe698084a2f441",
    zb_branch_id: "912468000001540296",
    autonumbergenerationgroup_id: "912468000002878601",
    autonumbergenerationgroup_name: "Sales Madhya Pradesh",
    branch_name: "Madhya Pradesh",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "23ABDCS8429E1ZE",
    tax_settings_id: "912468000001540291",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1:
        "C. No. 1, 2nd Floor, F 426, Industrial Area, Phase 8 B, SAS Nagar",
      street_address2: "",
      city: "Mohali",
      postal_code: "160055",
      country: "India",
      state: "Punjab",
      state_code: "PB",
    },
    _id: "648af94b25fe698084a2f44c",
    zb_branch_id: "912468000000124051",
    autonumbergenerationgroup_id: "912468000002878541",
    autonumbergenerationgroup_name: "Sales Punjab",
    branch_name: "Punjab",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "03ABDCS8429E1ZG",
    tax_settings_id: "912468000000124046",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1: "13A, Parvati Nagar Extension, Janpath, Shyam Nagar",
      street_address2: "",
      city: "Jaipur",
      postal_code: "302019",
      country: "India",
      state: "Rajasthan",
      state_code: "RJ",
    },
    _id: "648af94b25fe698084a2f457",
    zb_branch_id: "912468000000124021",
    autonumbergenerationgroup_id: "912468000002878571",
    autonumbergenerationgroup_name: "Sales Rajasthan",
    branch_name: "Rajasthan",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "08ABDCS8429E1Z6",
    tax_settings_id: "912468000000124016",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1: "Door No. 1/A, Kamaraj Nagar, Vadakailasam, Thorapadi",
      street_address2: "",
      city: "Cuddalore",
      postal_code: "607106",
      country: "India",
      state: "Tamil Nadu",
      state_code: "TN",
    },
    _id: "648af94b25fe698084a2f462",
    zb_branch_id: "912468000001540337",
    autonumbergenerationgroup_id: "912468000002878631",
    autonumbergenerationgroup_name: "Sales Tamil Nadu",
    branch_name: "Tamil Nadu",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "33ABDCS8429E1ZD",
    tax_settings_id: "912468000001540332",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1:
        "First Floor, Door No. 8-2-682/A and B, Flat No. 103, Block A,",
      street_address2: "Mayfair Gardens, Road No. 12, Banjara Hills,",
      city: "Hyderabad",
      postal_code: "500034",
      country: "India",
      state: "Telangana",
      state_code: "TS",
    },
    _id: "648af94b25fe698084a2f46d",
    zb_branch_id: "912468000002207042",
    autonumbergenerationgroup_id: "912468000002881001",
    autonumbergenerationgroup_name: "Sales Telangana",
    branch_name: "Telangana",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "36ABDCS8429E2Z6",
    tax_settings_id: "912468000002207007",
    website: "",
  },
  {
    address: {
      street_address1:
        "3rd Floor, Suite No. 37, B-8, Sector-2, Gautam Buddha Nagar",
      street_address2: "",
      city: "Noida",
      postal_code: "201301",
      country: "India",
      state: "Uttar Pradesh",
      state_code: "UP",
    },
    _id: "648af94b25fe698084a2f478",
    zb_branch_id: "912468000000124040",
    autonumbergenerationgroup_id: "912468000002878511",
    autonumbergenerationgroup_name: "Sales Uttar Pradesh",
    branch_name: "Uttar Pradesh",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "09ABDCS8429E1Z4",
    tax_settings_id: "912468000000124035",
    website: "Poshn.co",
  },
  {
    address: {
      street_address1: "Property No. 82, Neshvilla Road",
      street_address2: "",
      city: "Dehradun",
      postal_code: "248001",
      country: "India",
      state: "Uttarakhand",
      state_code: "UK",
    },
    _id: "648af94b25fe698084a2f484",
    zb_branch_id: "912468000003099327",
    autonumbergenerationgroup_id: "912468000003099297",
    autonumbergenerationgroup_name: "Sales Uttarakhand",
    branch_name: "Uttarakhand",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "05ABDCS8429E1ZC",
    tax_settings_id: "912468000003099199",
    website: "",
  },
  {
    address: {
      street_address1:
        "Unit No. 1016 and 1017, Plot No. 34/1, 10th Floor, Aurora Waterfront",
      street_address2: "Sector-V, GN Block, North Twenty Four Parganas",
      city: "Bidhannagar",
      postal_code: "700091",
      country: "India",
      state: "West Bengal",
      state_code: "WB",
    },
    _id: "648af94b25fe698084a2f490",
    zb_branch_id: "912468000003099257",
    autonumbergenerationgroup_id: "912468000003099227",
    autonumbergenerationgroup_name: "Sales West Bengal",
    branch_name: "West Bengal",
    email: "sales@poshn.co",
    fax: "",
    is_branch_active: true,
    is_primary_branch: false,
    phone: "",
    tax_reg_no: "19ABDCS8429E1Z3",
    tax_settings_id: "912468000003099217",
    website: "",
  },
];
